import { Component } from "react";
import { api } from "@/lib/api";
import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunkRecovery";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    if (isChunkLoadError(error) && reloadOnceForChunkError()) {
      return;
    }
    try {
      const payload = {
        type: error?.name || "UnknownError",
        message: error?.message || "",
        stack: error?.stack || "",
        componentStack: info?.componentStack || "",
        platform: "frontend",
        isFatal: true,
        severity: "critical",
      };
      api.post("/client-errors", payload).catch(() => {});
    } catch {
      // silent
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
          <div className="text-center max-w-md">
            <h1 className="font-display font-bold text-2xl text-foreground mb-3">Something went wrong</h1>
            <p className="text-muted-foreground mb-6">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="rounded-full h-12 px-6 bg-primary text-primary-foreground hover:bg-[#1a3025] font-semibold"
            >
              Refresh page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
